"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatestatesResponse = exports.updateUserAuthorizationData = exports.updateSelectedPaymentMethod = exports.updateRmsId = exports.updatePostValidateResponse = exports.updatePaymentResponse = exports.updatePaymentError = exports.updatePaymentDetailsResponse = exports.updateInitiatePaymentData = exports.updateGetPaymentMethodsResponse = exports.updateCustomData = exports.updateCartItems = exports.updateCartAmount = exports.updateBeforeSubmitResponse = exports.updateActivePaymentMethods = exports.registerAuthCallHandler = exports.UPDATE_USER_AUTHORIZATION_DATA = exports.UPDATE_STATES_RESPONSE = exports.UPDATE_SELECTED_PAYMENT_METHOD = exports.UPDATE_RMS_ID = exports.UPDATE_POST_VALIDATE_RESPONSE = exports.UPDATE_PAYMENT_RESPONSE = exports.UPDATE_PAYMENT_ERROR = exports.UPDATE_PAYMENT_DETAILS_RESPONSE = exports.UPDATE_INITIATE_PAYMENT_DATA = exports.UPDATE_GET_PAYMENT_METHODS_RESPONSE = exports.UPDATE_CUSTOM_DATA = exports.UPDATE_CART_ITEMS = exports.UPDATE_CART_AMOUNT = exports.UPDATE_BEFORE_SUBMIT_RESPONSE = exports.UPDATE_ACTIVE_PAYMENT_METHODS = exports.REGISTER_AUTH_CALL_HANDLER = void 0;
// All action types are defined here
var UPDATE_CUSTOM_DATA = '@@payment-js/UPDATE_CUSTOM_DATA';
exports.UPDATE_CUSTOM_DATA = UPDATE_CUSTOM_DATA;
var UPDATE_PAYMENT_RESPONSE = '@@payment-js/UPDATE_PAYMENT_RESPONSE';
exports.UPDATE_PAYMENT_RESPONSE = UPDATE_PAYMENT_RESPONSE;
var UPDATE_PAYMENT_DETAILS_RESPONSE = '@@payment-js/UPDATE_PAYMENT_DETAILS_RESPONSE';
exports.UPDATE_PAYMENT_DETAILS_RESPONSE = UPDATE_PAYMENT_DETAILS_RESPONSE;
var UPDATE_GET_PAYMENT_METHODS_RESPONSE = '@@payment-js/UPDATE_GET_PAYMENT_METHODS_RESPONSE';
exports.UPDATE_GET_PAYMENT_METHODS_RESPONSE = UPDATE_GET_PAYMENT_METHODS_RESPONSE;
var UPDATE_PAYMENT_ERROR = '@@payment-js/UPDATE_PAYMENT_ERROR';
exports.UPDATE_PAYMENT_ERROR = UPDATE_PAYMENT_ERROR;
var UPDATE_CART_AMOUNT = '@@payment-js/UPDATE_CART_AMOUNT';
exports.UPDATE_CART_AMOUNT = UPDATE_CART_AMOUNT;
var UPDATE_BEFORE_SUBMIT_RESPONSE = '@@payment-js/UPDATE_BEFORE_SUBMIT_RESPONSE';
exports.UPDATE_BEFORE_SUBMIT_RESPONSE = UPDATE_BEFORE_SUBMIT_RESPONSE;
var UPDATE_POST_VALIDATE_RESPONSE = '@@payment-js/UPDATE_POST_VALIDATE_RESPONSE';
exports.UPDATE_POST_VALIDATE_RESPONSE = UPDATE_POST_VALIDATE_RESPONSE;
var UPDATE_STATES_RESPONSE = '@@UPDATE_STATES_RESPONSE';
exports.UPDATE_STATES_RESPONSE = UPDATE_STATES_RESPONSE;
var UPDATE_RMS_ID = '@@UPDATE_RMS_ID';
exports.UPDATE_RMS_ID = UPDATE_RMS_ID;
var UPDATE_SELECTED_PAYMENT_METHOD = '@@payment-js/UPDATE_SELECTED_PAYMENT_METHOD';
exports.UPDATE_SELECTED_PAYMENT_METHOD = UPDATE_SELECTED_PAYMENT_METHOD;
var REGISTER_AUTH_CALL_HANDLER = '@@payment-js/REGISTER_AUTH_CALL_HANDLER';
exports.REGISTER_AUTH_CALL_HANDLER = REGISTER_AUTH_CALL_HANDLER;
var UPDATE_ACTIVE_PAYMENT_METHODS = '@@payment-js/UPDATE_ACTIVE_PAYMENT_METHODS';
// Specific to Paypal
exports.UPDATE_ACTIVE_PAYMENT_METHODS = UPDATE_ACTIVE_PAYMENT_METHODS;
var UPDATE_USER_AUTHORIZATION_DATA = '@@payment-js/@@paypal/UPDATE_USER_AUTHORIZATION_DATA';
exports.UPDATE_USER_AUTHORIZATION_DATA = UPDATE_USER_AUTHORIZATION_DATA;
var UPDATE_INITIATE_PAYMENT_DATA = '@@payment-js/@@paypal/UPDATE_INITIATE_PAYMENT_DATA';
exports.UPDATE_INITIATE_PAYMENT_DATA = UPDATE_INITIATE_PAYMENT_DATA;
var UPDATE_CART_ITEMS = '@@payment-js/UPDATE_CART_ITEMS';

// All action creators are defined here
/**
 * Updates the custom data provided by host application to context
 * @param {Object} data - Data provided by host application to be stored as custom data
 * @returns {Object} Action object of type UPDATE_CUSTOM_DATA -> stores custom data in context
 */
exports.UPDATE_CART_ITEMS = UPDATE_CART_ITEMS;
var updateCustomData = function updateCustomData(data) {
  return {
    type: UPDATE_CUSTOM_DATA,
    data: data
  };
};
/**
 * Stores payment response provided by Payment Plus in context
 * @param {Object} data - Payment Response provided by Payment Plus on authorization or initiatePayment call
 * @returns {Object} Action object of type UPDATE_PAYMENT_RESPONSE --> stores respective response in context
 */
exports.updateCustomData = updateCustomData;
var updatePaymentResponse = function updatePaymentResponse(payload) {
  return {
    type: UPDATE_PAYMENT_RESPONSE,
    payload: payload
  };
};
/**
 * Stores additional payment details provided by payment plus in context
 * @param {Object} payload - Auth validate response from Payment Plus
 * @returns {Object} Action object of type UPDATE_PAYMENT_DETAILS_RESPONSE --> stores response in context
 */
exports.updatePaymentResponse = updatePaymentResponse;
var updatePaymentDetailsResponse = function updatePaymentDetailsResponse(payload) {
  return {
    type: UPDATE_PAYMENT_DETAILS_RESPONSE,
    payload: payload
  };
};
/**
 * Stores response from payment methods call to payment plus in respective contexts
 * @param {Object} payload - payment methods response from Payment Plus
 * @returns {Object} Action object of type UPDATE_GET_PAYMENT_METHODS_RESPONSE --> stores response in contexts
 */
exports.updatePaymentDetailsResponse = updatePaymentDetailsResponse;
var updateGetPaymentMethodsResponse = function updateGetPaymentMethodsResponse(payload) {
  return {
    type: UPDATE_GET_PAYMENT_METHODS_RESPONSE,
    payload: payload
  };
};
/**
 * Stores error returned by payment plus while processing payment
 * @param {Object} payload - error returned from Payment Plus
 * @returns {Object} Action object of type UPDATE_PAYMENT_ERROR --> stores error in context
 */
exports.updateGetPaymentMethodsResponse = updateGetPaymentMethodsResponse;
var updatePaymentError = function updatePaymentError(error) {
  return {
    type: UPDATE_PAYMENT_ERROR,
    error: error
  };
};
exports.updatePaymentError = updatePaymentError;
var updatestatesResponse = function updatestatesResponse(payload) {
  return {
    type: UPDATE_STATES_RESPONSE,
    payload: payload
  };
};
exports.updatestatesResponse = updatestatesResponse;
var updateRmsId = function updateRmsId(payload) {
  return {
    type: UPDATE_RMS_ID,
    payload: payload
  };
};
exports.updateRmsId = updateRmsId;
var updateCartAmount = function updateCartAmount(payload) {
  return {
    type: UPDATE_CART_AMOUNT,
    payload: payload
  };
};
exports.updateCartAmount = updateCartAmount;
var updateCartItems = function updateCartItems(payload) {
  return {
    type: UPDATE_CART_ITEMS,
    payload: payload
  };
};
exports.updateCartItems = updateCartItems;
var updateSelectedPaymentMethod = function updateSelectedPaymentMethod(payload) {
  return {
    type: UPDATE_SELECTED_PAYMENT_METHOD,
    payload: payload
  };
};
exports.updateSelectedPaymentMethod = updateSelectedPaymentMethod;
var updateBeforeSubmitResponse = function updateBeforeSubmitResponse(payload) {
  return {
    type: UPDATE_BEFORE_SUBMIT_RESPONSE,
    payload: payload
  };
};
exports.updateBeforeSubmitResponse = updateBeforeSubmitResponse;
var updatePostValidateResponse = function updatePostValidateResponse(payload) {
  return {
    type: UPDATE_POST_VALIDATE_RESPONSE,
    payload: payload
  };
};
exports.updatePostValidateResponse = updatePostValidateResponse;
var registerAuthCallHandler = function registerAuthCallHandler(payload) {
  return {
    type: REGISTER_AUTH_CALL_HANDLER,
    payload: payload
  };
};
exports.registerAuthCallHandler = registerAuthCallHandler;
var updateActivePaymentMethods = function updateActivePaymentMethods(payload) {
  return {
    type: UPDATE_ACTIVE_PAYMENT_METHODS,
    payload: payload
  };
};

// Specific to Paypal alternate payment
exports.updateActivePaymentMethods = updateActivePaymentMethods;
var updateUserAuthorizationData = function updateUserAuthorizationData(payload) {
  return {
    type: UPDATE_USER_AUTHORIZATION_DATA,
    payload: payload
  };
};
exports.updateUserAuthorizationData = updateUserAuthorizationData;
var updateInitiatePaymentData = function updateInitiatePaymentData(payload) {
  return {
    type: UPDATE_INITIATE_PAYMENT_DATA,
    payload: payload
  };
};
exports.updateInitiatePaymentData = updateInitiatePaymentData;